<div class="portal-background"
     [ngClass]="{'about-background': isMobileDevice$ | async}">
  <div class="gradient">
    <div class="container">

      <!-- <section class="welcome-img">
        <a href="https://www.servicegambit.com"
           target="_blank">
          <img [src]="logo"
               alt="GWEBiz" /></a>
      </section> -->

      <h1 class="portal-title">{{APP_MENU_ABOUT}}</h1>
      <!-- <div>Welcome to the GWEBiz! </div> -->
      <section *ngIf="(isUserAuthenticated$ | async) === false"
               class="login-section get-started">
        <div class="actions login-notes ">
          <div [ngClass]="(isMobileDevice$ | async) ? 'mat-h2' : 'mat-h1'">
            <div class="pt-2 "> {{aboutStr}}</div>
            <!-- <div class="pt-2"> To obtain a Login/info please send an email to: <a
                 href="appInfoEmail">{{appInfoEmail}} </a></div>
                 <div class="pt-2 "> Or select Sign Up below</div> -->
          </div>
        </div>
        <div *ngIf="isLoading$ | async"
             class="d-flex justify-content-center">
          <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>


      </section>

      <!-- <div class="actions" *ngIf="(isUserAuthenticated$ | async)"> -->
      <div class="row justify-content-center">
        <!-- <a [ngClass]="routeAnimationsElements"
           mat-raised-button
           class="actions-main mr-2"
           color="primary"
           routerLink="../product-list">
          {{ appMenuPricing}}
        </a> -->
        <!-- <a *ngIf="(isUserAuthenticated$ | async) && (isClientSelected$ | async)"
           mat-raised-button
           class="actions-main"
           color="accent"
           [ngClass]="routeAnimationsElements"
           routerLink="/game-plan-view">
          {{ APP_MENU_GAME_PLANS}}
        </a> -->
        <a *ngIf="(isUserAuthenticated$ | async) === false"
           mat-raised-button
           class="actions-main mr-2"
           color="primary"
           [ngClass]="routeAnimationsElements"
           routerLink="/login">
          {{ APP_MENU_LOGIN}}
        </a> <a *ngIf="(isUserAuthenticated$ | async) === false"
           mat-raised-button
           class="actions-main mr-2"
           color="primary"
           [ngClass]="routeAnimationsElements"
           routerLink="/contact-us">
          {{ APP_MENU_CONTACT_US}}
        </a>
        <a *ngIf="(isUserAuthenticated$ | async)"
           mat-raised-button
           class="actions-main"
           color="primary"
           [ngClass]="routeAnimationsElements"
           routerLink="/dashboard">
          DashBoard
        </a>

        <!--
           (click)="navigateToGamePlans()"<a mat-raised-button
           class="actions-main"
           color="warn"
           routerLink="../settings"
           [ngClass]="routeAnimationsElements">
          {{ 'Service Events' }}
        </a> -->
        <!-- <a mat-raised-button
           class="actions-main"
           color="warn"
           href="https://www.servicegambit.com"
           target="_blank">
          Visit {{appParentCompany}}
        </a> -->
      </div>

    </div>
  </div>
</div>
